import { merge } from 'lodash';
import { APP_SETTINGS_VERSION_3 } from '@wix/wix-vod-constants/app-settings';

/* Don't change settings here! To change settings behavior, create new version */

/* This version includes addition of language parameter */

export function migrateToV3(appSettingsV2) {
  return merge({}, appSettingsV2, {
    numbers: {
      settingsVersion: APP_SETTINGS_VERSION_3
    },
    fonts: {
      language: ''
    }
  });
}
//# sourceMappingURL=version-3.js.map